import {Component, ChangeDetectionStrategy} from "@angular/core"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-template-menu",
    imports: [],
    templateUrl: "./template-menu.component.html",
    styleUrl: "./template-menu.component.scss",
})
export class TemplateMenuComponent {}
